/**
 * Where a letter cell opens (APP-130): the Letters page, Settings › Elections and letters ›
 * Letters, with `?cell=<key>`, the key being the domain's `letterCellKey`
 * (`SDB.<signerId>.cash_only`). An award's gap card links here. D96: the page has its own address,
 * outside the Settings frame; `?cell=` on Elections and letters itself (older links) redirects here.
 */
export const LETTERS_PAGE = '/settings/elections-letters/letters';

/** Elections and letters, where the Letters page came from. */
export const ELECTIONS_LETTERS_PAGE = '/settings/elections-letters';

/** The id of Elections and letters' Letters card, which Back to Settings lands on. */
export const LETTERS_CARD_ID = 'letters';

export function letterCellHref(key: string): string {
  return `${LETTERS_PAGE}?${new URLSearchParams({ cell: key }).toString()}`;
}
